// Client-side part-zoeklogica voor zoeken binnen een set.
// Spiegelt de semantiek van de backend-zoeker (backend/routes/sets.js):
// dimensiepatronen worden genormaliseerd ("1 x 1", "1x1", "1×1" → "1x1")
// en kleurnamen tellen gewoon mee in de zoektekst ("red plate" werkt).

// Collapse dimension patterns so "2 x 2 x 3" and "2x2x3" tokenize identically.
// The lookahead deliberately leaves the right-hand digit available for the
// next match, so chained dimensions are normalized in one pass.
function collapseDimensions(str) {
  return str.replace(/(\d)\s*[x×]\s*(?=\d)/gi, '$1x');
}

export function tokenizePartQuery(str) {
  return collapseDimensions(String(str).toLowerCase())
    .split(/\s+/)
    .filter(w => w.length > 0);
}

// Every query token must appear as a substring of the part's searchable text.
// The haystack includes the color name, so plain color queries ("red",
// "dark bluish gray") and combos ("red plate 1x2") match without extra UI.
export function buildPartHaystack(part) {
  return collapseDimensions(
    [part.name, part.partId, part.bl_part_id, part.part_ex_id, part.colorName]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
  );
}

export function partMatchesTokens(haystack, tokens) {
  return tokens.every(t => haystack.includes(t));
}
